import React from 'react';

import { BASE_URL } from 'consts';
import { useAuth } from 'hooks';
import { SectionTitle } from 'components';
import ChatSettings from './ChatSettings';

import styles from './ChatPreview.module.scss';

const ChatPreview = props => {
  const { event, access = 'admin', showSettings } = props;
  const auth = useAuth();

  if (!event || !event._id || !auth || !auth.user) {
    return null;
  }

  const renderTitle = () => (
    <div className={styles.title}>
      <SectionTitle title="Live Chat">
        Here are all messages and interactions sent to users.
      </SectionTitle>
    </div>
  );

  return (
    <div className={styles.chat}>
      <div className={styles.header}>
        {renderTitle()}
        {showSettings && event.game ? <ChatSettings event={event} /> : null}
      </div>

      <iframe
        className={styles.iframe}
        title="preview"
        src={`${BASE_URL}/hostwebapp/${event._id}/${auth.user._id}/${auth.token}/${access}/`}
        width="375"
        height="667"
      />
    </div>
  );
};

export default ChatPreview;
